import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const leaderboardSlice = createAppSlice({
  name: 'leaderboard',
  initialState,
  reducers,
});

export const { loadActionPoints, updateActionPoints } = leaderboardSlice.actions;

export default leaderboardSlice.reducer;
